import { hysteriFetch, wrappers } from 'hysterics';

const defaultPagesClientService = hysteriFetch('defaultPagesClientService', {
	timeout: {
		timeout: 1900
	},
	[wrappers.retry.contextKey]: {
		retries: 1
	}
});

export default async function fetchDefaultPages({
	aliases,
	siteId,
	locale,
	widgetSearchServiceUri = ''
}) {
	const response = await defaultPagesClientService(
		`${widgetSearchServiceUri}/pageSearch/title/${siteId}/${locale}?aliases=${encodeURIComponent(
			aliases
		)}`
	);
	return response;
}
